/**
 * 問題の制限時間（problem-format.md §2.2 time_limit_sec、類題は exerciseTimeLimit）を判定に適用する。
 * sandboxd の打ち切りは 1 ケース 3 秒なので、それより短い制限を超えたケースは画面側で TLE にする。
 * 1 ケースでも超えれば全体は TLE（全体はもっとも重い判定。judge.md §3.3）。
 */
import { aggregateVerdicts, type JudgeResult } from '../../lib/judge';

export function applyTimeLimit(judge: JudgeResult, limitSec: number): JudgeResult {
  if (judge.overall === 'CE') return judge;
  const limitMs = limitSec * 1000;
  const cases = judge.cases.map((c) =>
    (c.verdict === 'AC' || c.verdict === 'WA') && c.durationMs !== null && c.durationMs > limitMs
      ? { ...c, verdict: 'TLE' as const }
      : c,
  );
  return {
    ...judge,
    cases,
    overall: aggregateVerdicts(cases.map((c) => c.verdict)),
    acCount: cases.filter((c) => c.verdict === 'AC').length,
  };
}

/** 制限時間を超えたケースか（「制限を超えています」の注記に使う） */
export function overLimit(durationMs: number | null, limitSec: number): boolean {
  return durationMs !== null && durationMs > limitSec * 1000;
}
